"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromRawMap = void 0;
const Utils_1 = require("../Utils/Utils");
function comparator(a, b) {
    const dt = a.time - b.time;
    if (dt)
        return dt;
    return a.lane - b.lane;
}
function fromRawMap(map) {
    map.notes = map.notes.sort(comparator);
    const slideset = new Map();
    const slidenotes = new Map();
    for (const s of map.slides) {
        slideset.set(s.id, {
            type: "slide",
            flickend: s.flickend,
            notes: [],
        });
    }
    for (const n of map.notes) {
        if (n.type === "slide") {
            const list = slidenotes.get(n.slideid);
            if (!list)
                slidenotes.set(n.slideid, [n]);
            else
                list.push(n);
        }
    }
    const notes = [];
    const simlines = [];
    const bars = [];
    const timeMap = new Map();
    for (const n of map.notes) {
        if (n.type !== "slide") {
            notes.push(Object.assign({}, n));
        }
        else {
            const s = slideset.get(n.slideid);
            if (!s)
                throw new Error("Can not find slide for note");
            const l = slidenotes.get(n.slideid);
            if (!l)
                throw new Error("Never happens");
            if (l.length < 2)
                throw new Error("Slide can not have less than 2 notes");
            if (n === l[0]) {
                notes.push({ type: "slidestart", parent: s, time: n.time, lane: n.lane });
                const start = Utils_1.findex(notes, -1);
                s.notes.push(start);
            }
            else {
                if (n === l[l.length - 1]) {
                    if (s.flickend)
                        notes.push({ type: "flickend", parent: s, time: n.time, lane: n.lane });
                    else
                        notes.push({ type: "slideend", parent: s, time: n.time, lane: n.lane });
                }
                else
                    notes.push({ type: "slideamong", parent: s, time: n.time, lane: n.lane });
                const start = Utils_1.findex(s.notes, -1);
                const end = Utils_1.findex(notes, -1);
                s.notes.push(end);
                bars.push({ type: "slidebar", start, end });
            }
        }
        const right = Utils_1.findex(notes, -1);
        if (right.type !== "slideamong") {
            const left = timeMap.get(n.time);
            if (left) {
                simlines.push({ type: "simline", left, right });
            }
            timeMap.set(n.time, right);
        }
    }
    notes.sort(comparator);
    simlines.sort((a, b) => comparator(a.left, b.left));
    bars.sort((a, b) => comparator(a.start, b.start));
    return { notes, bars, simlines, combo: notes.length };
}
exports.fromRawMap = fromRawMap;
//# sourceMappingURL=GameMap.js.map